module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ad64af1465b1d5d22d82e5d17a2a7b49.png";